// import { createSelector } from 'reselect';
import { RESIDENT_ONBOARDING_REDUCER } from './reducer';

const _selectResidentOnboradingReducer = (state) =>
  state[RESIDENT_ONBOARDING_REDUCER];

export const selectResidentPersonalInfo = (state) =>
  _selectResidentOnboradingReducer(state).residentPersonalInfo;
